export default [
  {
    name: 'Dashboard.Index',
    path: '',
    component: () => import('./components/Dashboard')
  }
]
